import React from 'react';
import { FixedSizeList as List } from "react-window";
import { SelectedMenuItemsComponent } from './SelectedMenuItemsComponent';
import IMenuItemBody from '../../../../../interfaces/IMenuItemBody';
export default interface ISelectedItemsListProps {
    itemsList: IMenuItemBody[];
    onDelete: (id: string) => void;
    disableButton: boolean;
    fieldList?: any[];
}
export function SelectedItemsList(props: ISelectedItemsListProps) {
    function Row({ index, style }: any) {
        const item = props?.itemsList[index];
        return (
            <div style={style} key={index} data-component-name="DiscountsItem">
                <SelectedMenuItemsComponent deleteDisabled={props.disableButton} itemData={item} onDelete={props.onDelete} fields={props.fieldList} />
            </div>
        );
    }
    return (
        <div style={{
            width: "100%",
            height: "100%",
            paddingTop: "1rem"
        }} id="ListWrapper">
            <List height={200}
                itemCount={props?.itemsList?.length}
                itemSize={76}
                width={"100%"}
                style={{
                    paddingBottom: "3.5rem",
                    overflow: "auto",
                }}
            >
                {Row}
            </List>

        </div>
    )
}
